import { XIcon } from 'lucide-preact';

import { cn } from '@/lib/utils';

import AnimalAlertButton from './AnimalAlertButton';
import { ANIMAL_ALERT_TYPES, AnimalAlertType } from './constants';
import { useFlaggedAnimalAlertType } from './useFlaggedAnimalAlertType';

interface AnimalAlertPopoverProps {
  open?: boolean;
  habitatId: string;
  disabled?: boolean;
  className?: string;
  onClose?: () => void;
  onSelect?: (alertType: AnimalAlertType) => void;
}

const AnimalAlertPopover = ({
  open = true,
  habitatId,
  disabled = false,
  className,
  onClose,
  onSelect,
}: AnimalAlertPopoverProps) => {
  const flaggedAlertType = useFlaggedAnimalAlertType(habitatId);

  if (!open) {
    return null;
  }

  return (
    <div className={cn('z-[2] flex w-[260px] flex-col', className)}>
      <div className="relative flex flex-col rounded-lg bg-white px-2 pb-2 pt-1 shadow-[0_4px_12px_0_rgba(0,0,0,0.20)]">
        <div className="flex justify-between gap-2">
          <div className="text-xs text-forest-core">
            <div className="flex items-center justify-between gap-2">
              <h3 className="preflight preflight-h3 font-bold">
                {flaggedAlertType ? '🔥 Boosted.' : 'Spot something amazing? Flag it!'}
              </h3>
              <button
                type="button"
                className="preflight preflight-button -m-2 p-2 text-xs text-forest-darkest"
                aria-label="Close animal alert selector"
                onClick={onClose}
              >
                <XIcon className="block size-4" strokeWidth={2} />
              </button>
            </div>
            <p className="preflight preflight-p mt-1">
              {flaggedAlertType
                ? 'You just helped to feature this habitat more on the home page!'
                : 'When many people react, animal fans get notified about unmissable moments'}
            </p>
          </div>
        </div>

        <div className="mt-3 flex flex-wrap gap-2">
          {ANIMAL_ALERT_TYPES.map((alertType) => (
            <AnimalAlertButton
              key={alertType}
              alertType={alertType}
              selected={flaggedAlertType === alertType}
              disabled={disabled}
              onClick={() => onSelect?.(alertType)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnimalAlertPopover;
